export default Object.freeze({
  DATE: {
    PARAM_ID: 239,
    EQUALS: '1',
    NOT_EQUALS: '2',
    GREATER_THAN: '3',
    GREATER_THAN_EQUAL: '4',
    LESS_THAN: '5',
    LESS_THAN_EQUAL: '6',
    EMPTY: '7',
    NOT_EMPTY: '8',
    RANGE: '9',
  },
  NUMBER: {
    PARAM_ID: 240,
    EQUALS: '1',
    NOT_EQUALS: '2',
    GREATER_THAN: '3',
    GREATER_THAN_EQUAL: '4',
    LESS_THAN: '5',
    LESS_THAN_EQUAL: '6',
    EMPTY: '7',
    NOT_EMPTY: '8',
    RANGE: '9',
  },
  SELECT: {
    PARAM_ID: 241,
    EQUALS: '1',
    EMPTY: '2',
    NOT_EMPTY: '3',
    EQUAL_OR_EMPTY: '4',
  },
  STRING: {
    PARAM_ID: 242,
    CONTAINS: '1',
    EQUALS: '7',
    EMPTY: '9',
    NOT_EMPTY: '10',
  },
  GUID: {
    PARAM_ID: 243,
    // operations: {} // not used always equals
  },
  PERCENTAGE: {
    PARAM_ID: 262,
    EQUALS: '1',
    NOT_EQUALS: '2',
    GREATER_THAN: '3',
    GREATER_THAN_EQUAL: '4',
    LESS_THAN: '5',
    LESS_THAN_EQUAL: '6',
    EMPTY: '7',
    NOT_EMPTY: '8',
    RANGE: '9',
  },
});
